import { useState, useRef } from "react";
import axios from "axios";
import "./style.scss";
import Alert from "@mui/material/Alert";
import { dataUriToBuffer } from "data-uri-to-buffer";
import { useSearchParams } from "react-router-dom";

export default function ImageUploadPage() {
  const [params] = useSearchParams();
  const dbObjId = params.get("id");
  const [message, setMessage] = useState("");
  const [images, setImages] = useState([]);
  const [isProcessMessage, setIsProcessMessage] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false);
  const url = process.env.REACT_APP_DEPPLOYED;

  const addImage = async (img) => {
    let extension = img.name.split(".").pop();
    const fileReader = new FileReader();
    fileReader.readAsDataURL(img);
    fileReader.onload = () => {
      setImages((oldArray) => [
        ...oldArray,
        { image: fileReader.result, extension: extension },
      ]);
    };
  };

  const handleDeleteImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const submit = async () => {
    try {
      setIsProcessMessage(true)
      console.log(params);
      document.getElementById("img_submit").style.display = "none";
      const keys = [];

      for (let image of images) {
        let params = { dbObjId: dbObjId, extension: image.extension };
        console.log(params);

        const {
          data: { uploadUrl, key },
        } = await axios.get(`${url}/coupons/images/uploadUrl`, { params });

        console.log("image", image);
        try {
          await axios.put(uploadUrl, image.image, {
            headers: { "Content-Type": image.extension },
          });
          keys.push(key);
        } catch (uploadError) {
          console.error("Error uploading image:", uploadError);
          setMessage("Failed to upload one or more images. Please try again.");
          setIsProcessMessage(false)
          return;
        }
      }

      try {
        await axios.post(`${url}/coupons/images/saveKeys`, { dbObjId, keys });
        setIsSubmitted(true);
        setMessage("Images are submitted")
      } catch (saveKeysError) {
        console.error("Error saving keys:", saveKeysError);
        setMessage("Failed to save image keys. Please try again.");
        setIsProcessMessage(false)
      }
    } catch (error) {
      console.error("Error during submission:", error);
      setMessage("An unexpected error occurred. Please try again.");
      setIsProcessMessage(false)
    }
  };

  return (
    <main className="image-page">
      {isSubmitted ? (
        <>
          <h2>Pictures are submitted</h2>
        </>
      ) : (
        <>
          {console.log(images)}
          <h2>Please attach the image of envelope</h2>
          {message === "" ? (
            <>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  addImage(e.target.files[0]);
                }}
              />
              {images.length > 0 && (
                <div className="show-image">
                  <h3>Click on photo for deleting</h3>
                  <div className="images-container">
                    {images.map((imageObj, i) => (
                      <img
                        key={i}
                        src={imageObj.image}
                        alt={`Preview ${i}`}
                        style={{ width: 200, cursor: "pointer" }}
                        onClick={() => handleDeleteImage(i)}
                      />
                    ))}
                  </div>
                  {!isProcessMessage?
                  (<button
                    className="btn"
                    onClick={() => {
                      submit();
                    }}
                    id="img_submit"
                  >
                    Submit
                  </button>):
                  <p>Processing...</p>
                  
                }
                </div>
              )}
            </>
          ) : (
            <h2>{message}</h2>
          )}
        </>
      )}
    </main>
  );
}
